<template>
  <p
      class="loading"
  >
    <span style="animation-delay: 0.6s">.</span>
    <span style="animation-delay: 0.4s">.</span>
    <span style="animation-delay: 0.2s">.</span>
  </p>
</template>

<script>
export default {
  name: "UIMiniLoader"
}
</script>

<style scoped>

@keyframes move-dots {
  0% {
    transform: translateY(0);
  }

  33% {
    transform: translateY(5px);
  }

  66% {
    transform: translateY(-5px);
    opacity: 0;
  }

  99% {
    transform: translateY(0);
    opacity: 1;
  }
}


.loading {
  width: 50px;
  height: 50px;
  margin: 0 auto;
  border-radius: 50%;

  text-align: center;
  font-size: 28px;
  line-height: 30px;
  letter-spacing: 2px;

  background: linear-gradient(93.81deg, #1ea89c 0%, #006c68 100%);
  color: white;
}

.loading span {
  display: inline-block;

  animation-name: move-dots;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

</style>
